const namespaced = true
import api from '../../api/entrance_tickets.js';
import _ from "lodash";

const state = {
    requestesdTickets: [],
    requestesdBackupTickets: [],
    loadingTicket: false,
    loadingNewTicket: false,
}
const mutations = {
    SET_TICKETS(state, data) {
        state.requestesdTickets = data;
        state.requestesdBackupTickets = data;
    },
    SET_LOADING_TICKET(state, data) {
        state.loadingTicket = data;
    },
    ADD_NEW_TICKET(state, data) {
        state.requestesdBackupTickets.unshift(data);
        state.requestesdTickets = state.requestesdBackupTickets;
    },
    SET_NEW_LOADING_TICKET(state, data) {
        state.loadingNewTicket = data;
    },
    DELETE_COMPLETED_TICKET(state, data) {
        const index = state.requestesdBackupTickets.findIndex( item => item.id === data.id );
        if (index !== -1) {
            state.requestesdBackupTickets.splice(index, 1);
        }
        state.requestesdTickets = state.requestesdBackupTickets;
    },
    CHANGE_TICKET_STATUS(state, data) {
        state.requestesdBackupTickets.find(item => item.id === data.id).completed = data.completed;
        state.requestesdTickets = state.requestesdBackupTickets;
    },
    UPDATE_ITEM_DATE_OUT(state, data) {
        state.requestesdBackupTickets.find(item => item.id === data.entranceTicket_id).entrnaceRecords.find(item => item.id === data.id).item_out_date = data.item_out_date;
        state.requestesdBackupTickets.find(item => item.id === data.entranceTicket_id).entrnaceRecords.find(item => item.id === data.id).in_plant = data.in_plant;
        state.requestesdTickets = state.requestesdBackupTickets;
    },
    SET_FILTER(state, data) {
        state.requestesdTickets = state.requestesdBackupTickets;
        if(!data){
            return state.requestesdTickets;
        }
        let sp = data.toLowerCase().split(" ");
        state.requestesdTickets = _.filter(state.requestesdTickets, (req) => {
            return _.every(sp, (keyword) => {
                let requisitionFields = [
                    req.id,
                    req.user_name,
                    req.user_email,
                    req.supplier_name,
                    req.card_code,
                    req.company_name,
                    req.date_out,

                ];
                let requisitionMatch = _.some(requisitionFields, (field) =>
                    field != null && _.includes(field.toString().toLowerCase(), keyword)
                );
                let linesMatch = _.some(req.entrnaceRecords, (line) =>
                    _.some([
                        line.item_name,
                        line.quantity,
                        line.extra_data,
                    ], (field) =>
                        field != null && _.includes(field.toString().toLowerCase(), keyword)
                    )
                );
                return requisitionMatch || linesMatch;
            });
        });
    },
}
const actions = {
    indexTickets(context) {
        context.commit('SET_LOADING_TICKET', true);
        return new Promise((resolve) => {
            api.index().then(function (res) {
                context.commit('SET_TICKETS', res.data.data);
                resolve(res.data.data);
                context.commit('SET_LOADING_TICKET', false);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOADING_TICKET', false);
            })
        })
    },
    indexTicketsWithFilter(context, data) {
        context.commit('SET_LOADING_TICKET', true);
        return new Promise((resolve) => {
            api.indexTicketsWithFilter(data).then(function (res) {
                context.commit('SET_TICKETS', res.data.data);
                resolve(res.data.data);
                context.commit('SET_LOADING_TICKET', false);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOADING_TICKET', false);
            })
        })
    },
    storeTicket(context, data) {
        context.commit('SET_NEW_LOADING_TICKET', true);
        return new Promise((resolve) => {
            api.storeTicket(data).then(function (res) {
                context.commit('ADD_NEW_TICKET', res.data.data);
                resolve(res);
                context.commit('SET_NEW_LOADING_TICKET', false);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_NEW_LOADING_TICKET', false);
            })
        })
    },

    completeTicket(context, data) {
        context.commit('SET_NEW_LOADING_TICKET', true);
        return new Promise((resolve) => {
            api.completeTicket(data).then(function (res) {
                resolve(res);
                context.commit('SET_NEW_LOADING_TICKET', false);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_NEW_LOADING_TICKET', false);
            })
        })
    },
    deleteTicket(context, data){
        context.commit('DELETE_COMPLETED_TICKET', data);
    },
    changeTicketStatus(context, data){
        context.commit('CHANGE_TICKET_STATUS', data);
    },

    takeItemOut(context, data) {
        context.commit('SET_NEW_LOADING_TICKET', true);
        return new Promise((resolve) => {
            api.takeItemOut(data).then(function (res) {
                resolve(res);
                context.commit('SET_NEW_LOADING_TICKET', false);
            }).catch((e) => {
                console.log(e);
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_NEW_LOADING_TICKET', false);
            })
        })
    },
    itemOutAction(context, data){
        if (data.headers.status === 'itemCompleted') {
            context.commit('UPDATE_ITEM_DATE_OUT', data.data);
            context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': 'Se la salida del objeto se completo.' }, { root: true });
        } else if (data.headers.status === 'ticketCompleted') {
            context.commit('DELETE_COMPLETED_TICKET', data.data);
            context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': 'Se cerro completamente la solicitud.' }, { root: true });
        }
    },
    changeItemStatus(context, data ){
        if (data.response.headers.status === 'itemCompleted') {
            context.commit('UPDATE_ITEM_DATE_OUT', data.response.data);
        } else if (data.response.headers.status === 'ticketCompleted') {
            const itemFind = data.response.data.entrnaceRecords.find(item => item.id === data.itemId);
            itemFind.entranceTicket_id = data.response.data.id;
            context.commit('UPDATE_ITEM_DATE_OUT', itemFind);
            context.commit('CHANGE_TICKET_STATUS', data.response.data);
        }
    },
    searchSelectedTickets(context, data) {
        context.commit('SET_FILTER', data);
    }
}
const getters = {
    getValueTickets(state) {
        return state.requestesdTickets;
    },
}

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}